import config from "@/config"
import http from "@/utils/request"
import { DemandStatus } from "@/utils/constants"
export default {
  requirement: {
    manage: {
      url: `${config.API_URL}/requirement/manage`,
      requirementOperateUrl: `${config.API_URL}/requirementOperate/manage`,
      name: "获取待审核需求列表",
      get: async function (params) {
        return await http.get(`${this.url}/getUnApplyRequirementList`, params)
      },
      submit: async function (data) {
        return await http.post(`${this.url}/checkRequirement`, data) //对需求单进行审核
      },
      del: async function (data) {
        return await http.post(`${this.url}/delete`, data)
      },
      getOperates: async function (params) {
        return await http.get(`${config.API_URL}/requirementOperate/manage/getOperationsById`, params)
      }
    },
    user: {
      url: `${config.API_URL}/requirement/user`,
      name: "创建待审核需求单",
      create: async function (data) {
        return await http.post(`${this.url}/createRequirement`, data) //对需求单进行审核
      },
      list: async function (params) {
        return await http.get(`${this.url}/getUserRequirementList`, params) //对需求单进行审核
      },
    }
  },
  biddingRequirement: {
    url: `${config.API_URL}/requirement/manage`,
    name: "获取正在招标的需求列表",
    get: async function (params) {
      return await http.get(`${this.url}/getBiddingRequirementList`, params)
    },
    del: async function (data) {
      return await http.post(`${this.url}/downRequirement`, data) //下架招标中的需求
    }
    // submit: async function (data) {
    //   return await http.post(`${this.url}/checkRequirement`, data) //对需求单进行审核
    // }
  },
  getDownList: {
    url: `${config.API_URL}/requirement/manage`,
    name: "获取下架的需求列表",
    get: async function (data) {
      return await http.post(`${config.API_URL}/requirement/manage/getList`, { ...data, status: DemandStatus.DOWN })
    }
  },
  list: {
    getRejectedList: {
      get: async function (data) {
        return await http.post(`${config.API_URL}/requirement/manage/getList`, { ...data, status: DemandStatus.REJECTED })
      }
    },
    getunUsedList: {
      get: async function (data) {
        return await http.post(`${config.API_URL}/requirement/manage/getList`, { ...data, status: DemandStatus.SELECTED })
      }
    },
    getBiddingList: {
      get: async function (params) {
        return await http.get(`${config.API_URL}/requirement/manage/getBiddingRequirementList`, params)
      }
    }
  }
}
